import { Input } from "antd";

const CreateContractPeriodeEssai = ({ contract, setContract }) => {
  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <p className="text-sm font-semibold text-left text-slate-900">
          Periode d'essai
        </p>

        <div className="flex mt-3 flex-col space-y-2">
          <p className="text-sm font-semibold text-slate-900">
            Contrat de 1 mois maximum : 2 jours max
          </p>
          <p className="text-sm font-semibold text-slate-900">
            Contrat de mission de 1 à 2 mois : 3 jours max
          </p>
          <p className="text-sm font-semibold text-slate-900">
            Contrat de mission de plus de 2 mois : 5 jours max
          </p>
          <Input
            onChange={(e) =>
              setContract({ ...contract, NbJourEssai: e.target.value })
            }
            value={contract.NbJourEssai ? contract.NbJourEssai : null}
            placeholder="Periode d'essai"
          />
        </div>
      </div>
    </div>
  );
};

export default CreateContractPeriodeEssai;
